<svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 13L9 13" stroke="#DADADA" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1 7H17" stroke="#DADADA" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 1L17 1" stroke="#DADADA" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
